import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// English feature files
import enAdmin from './locales/en/admin.json'
import enAgents from './locales/en/agents.json'
import enApp from './locales/en/app.json'
import enAuth from './locales/en/auth.json'
import enBusinesses from './locales/en/businesses.json'
import enChangelog from './locales/en/changelog.json'
import enCommon from './locales/en/common.json'
import enDashboard from './locales/en/dashboard.json'
import enErrors from './locales/en/errors.json'
import enExchangePacks from './locales/en/exchangePacks.json'
import enExchanges from './locales/en/exchanges.json'
import enIacrm from './locales/en/iacrm.json'
import enLanguage from './locales/en/language.json'
import enLegal from './locales/en/legal.json'
import enNavigation from './locales/en/navigation.json'
import enNotifications from './locales/en/notifications.json'
import enOnboarding from './locales/en/onboarding.json'
import enPayouts from './locales/en/payouts.json'
import enPoints from './locales/en/points.json'
import enPrograms from './locales/en/programs.json'
import enProspects from './locales/en/prospects.json'
import enPublicPortal from './locales/en/publicPortal.json'
import enSettings from './locales/en/settings.json'
import enSystem from './locales/en/system.json'
import enTable from './locales/en/table.json'
import enTheme from './locales/en/theme.json'
import enTransactions from './locales/en/transactions.json'

// French feature files
import frAdmin from './locales/fr/admin.json'
import frAgents from './locales/fr/agents.json'
import frApp from './locales/fr/app.json'
import frAuth from './locales/fr/auth.json'
import frBusinesses from './locales/fr/businesses.json'
import frChangelog from './locales/fr/changelog.json'
import frCommon from './locales/fr/common.json'
import frDashboard from './locales/fr/dashboard.json'
import frErrors from './locales/fr/errors.json'
import frExchangePacks from './locales/fr/exchangePacks.json'
import frExchanges from './locales/fr/exchanges.json'
import frIacrm from './locales/fr/iacrm.json'
import frLanguage from './locales/fr/language.json'
import frLegal from './locales/fr/legal.json'
import frNavigation from './locales/fr/navigation.json'
import frNotifications from './locales/fr/notifications.json'
import frOnboarding from './locales/fr/onboarding.json'
import frPayouts from './locales/fr/payouts.json'
import frPoints from './locales/fr/points.json'
import frPrograms from './locales/fr/programs.json'
import frProspects from './locales/fr/prospects.json'
import frPublicPortal from './locales/fr/publicPortal.json'
import frSettings from './locales/fr/settings.json'
import frSystem from './locales/fr/system.json'
import frTable from './locales/fr/table.json'
import frTheme from './locales/fr/theme.json'
import frTransactions from './locales/fr/transactions.json'

const en = {
  ...enAdmin,
  ...enAgents,
  ...enApp,
  ...enAuth,
  ...enBusinesses,
  ...enChangelog,
  ...enCommon,
  ...enDashboard,
  ...enErrors,
  ...enExchangePacks,
  ...enExchanges,
  ...enIacrm,
  ...enLanguage,
  ...enLegal,
  ...enNavigation,
  ...enNotifications,
  ...enOnboarding,
  ...enPayouts,
  ...enPoints,
  ...enPrograms,
  ...enProspects,
  ...enPublicPortal,
  ...enSettings,
  ...enSystem,
  ...enTable,
  ...enTheme,
  ...enTransactions,
}

const fr = {
  ...frAdmin,
  ...frAgents,
  ...frApp,
  ...frAuth,
  ...frBusinesses,
  ...frChangelog,
  ...frCommon,
  ...frDashboard,
  ...frErrors,
  ...frExchangePacks,
  ...frExchanges,
  ...frIacrm,
  ...frLanguage,
  ...frLegal,
  ...frNavigation,
  ...frNotifications,
  ...frOnboarding,
  ...frPayouts,
  ...frPoints,
  ...frPrograms,
  ...frProspects,
  ...frPublicPortal,
  ...frSettings,
  ...frSystem,
  ...frTable,
  ...frTheme,
  ...frTransactions,
}

const resources = {
  en: { translation: en },
  fr: { translation: fr },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    debug: false,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'hd-parrainage-language',
    },
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
